/**
 * Ordine di impilamento della "chrome" fissa dell'app (fab AI, chip di
 * versione) e degli overlay che devono coprirla.
 *
 * Storicamente questi elementi usano `9999999999999`, valore fuori range che
 * ogni browser riporta al massimo CSS (`2147483647`): fab, chip e qualunque
 * bottom sheet finivano sullo stesso livello e l'ordine veniva deciso dalla
 * posizione nel DOM. Tenendo la chrome un gradino sotto il massimo l'ordine
 * diventa esplicito: `TOP_OVERLAY_Z_INDEX` vince sempre, mentre il resto
 * dell'app non cambia (gli z-index di MUI si fermano a 1500).
 */
export const FLOATING_CHROME_Z_INDEX = 2147483646;

/** Overlay che devono stare sopra fab AI e chip di versione (es. bottom sheet). */
export const TOP_OVERLAY_Z_INDEX = 2147483647;
